import { ProgressSpinnerService } from './../services/progress-spinner.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { AuthGuard } from './../../auth.guard';
import { AuthService } from './../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  private _tokenizedReq: any;
  private _currentRoute: any;
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private _activeRequests = 0;

  constructor(private _authService: AuthService, private _router: Router, private _progressSpinnerService: ProgressSpinnerService) { }

  private _finalizeRequest(): void {
    this._activeRequests -= 1;
    if (this._activeRequests <= 0) {
      this._progressSpinnerService.progressSpinnerChange(false);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._activeRequests += 1;
    this._progressSpinnerService.progressSpinnerChange(true);
    if (req.url === this._authService.refreshTokenUrl) {
      return next.handle(req).pipe(catchError(error => {
        if (error) {
          this._router.navigate([this._authService.loginUrl]);
          this._progressSpinnerService.progressSpinnerChange(false);
          return throwError(error);
        }
      }));
    } else {
      const token = this._authService.getLocalToken();

      if (token) {
        req = this.addToken(req, token);
      } else {
        this._router.navigate([this._authService.loginUrl]);
      }

      return next.handle(req).pipe(catchError(error => {
        if (error?.status === 401 || error?.status === 403) {
          return this.handle401Error(req, next).pipe(finalize(() => {
            this._finalizeRequest();
          }));
        } else {
          this._router.navigate([this._authService.loginUrl]);
          this.isRefreshing = false;
          this._progressSpinnerService.progressSpinnerChange(false);
          return throwError(error);
        }
      }), finalize(() => {
        this._finalizeRequest();
      }));

    }

  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ` + token
      }
    });

  }


  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    this.isRefreshing = true;
    this.refreshTokenSubject.next(null);

    return this._authService.refreshToken().pipe(
      switchMap((token: any) => {
        this.isRefreshing = false;
        this.refreshTokenSubject.next(token.access);
        return next.handle(this.addToken(request, token.access)).pipe(finalize(() => {
          this._finalizeRequest();
        }));
      }));
  }

}
